import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rgFormat',
})
export class RgFormat implements PipeTransform {
  transform(value: string): any {
    return value.replace(
      /^(\d{2})\D*(\d{3})\D*(\d{3})\D*(\d{1})$/g,
      '$1.$2.$3-$4',
    );
  }
}
